import React from 'react';

/* eslint-disable react/prop-types */
const TableHeaderRow = props => {
  return <tr>{props.children}</tr>;
};
export default TableHeaderRow;
